<template>
  <div class="imgUpload">
    <el-upload
      :disabled="disabled"
      class="avatar-uploader"
      action="image/upload-img-files"
      accept=".jpg,.png,.jpeg,.gif,.JPG,.PNG,.JPEG,.GIF"
      :show-file-list="false"
      :auto-upload="true"
      :http-request="upload"
      :on-change="handleChange"
      :on-success="handleSuccess"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <a v-if="imageUrl" href="javascript:void(0)">
        <div class="mask">
          <el-button type="text" icon="el-icon-search" @click="disVis= true" class="mask_btn"></el-button>
          <el-button
            type="text"
            v-if="!disabled"
            icon="el-icon-delete"
            class="mask_btn"
            @click.stop.prevent="deleteImg"
          ></el-button>
        </div>
      </a>
    </el-upload>
    <el-dialog :visible.sync="disVis">
      <img width="100%" :src="imageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "img-upload",
  props: {
    disabled: Boolean,
    fileList: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imageUrl: "",
      disVis: false,
      upFile: {},
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler: function(val) {
        if (val && val !== "") {
          this.imageUrl = val;
        }
      }
    }
  },
  methods: {
    handleChange(file, fileList) {
      this.upFile= file
    },
    deleteImg() {
      this.imageUrl = "";
      this.$emit("getFileList", this.imageUrl);
    },
    handleSuccess(res, file, fileList) {
      const {ret}= res
      if(ret) {
        this.imageUrl= res.data.imgUrl;
        this.$emit('getFileList', this.imageUrl)
      }else {
        this.imageUrl = "";
        this.$message({
          type: "warning",
          message: "网络异常，请重新上传"
        })
      }
    },
    async upload() {
      let { raw, name }= this.upFile
      let formData = new FormData();
      formData.append('files', raw, name)
      return await _api.store.uploadImgFiles(formData);
    },
  }
};
</script>

<style scoped>
.avatar-uploader {
  position: relative;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
.mask {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 146px;
  height: 146px;
  color: #fff;
  background: rgba(101, 101, 101, 0.8);
}
.mask_btn {
  color: #fff;
  margin: 61px 30px;
}
.avatar-uploader a:hover .mask {
  opacity: 1;
}
.imgUpload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  width: 148px;
  height: 148px;
}
</style>